import {
  HeartIcon,
  ClockIcon,
  SparklesIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";
import { classNames } from "../utils/functions";
import { ProfileTabsProps, TabData } from "../../types/Profile";

export default function ProfileTabs({ 
  activeTab, 
  setActiveTab, 
  outfits, 
  favouritesCount 
}: ProfileTabsProps) {
  const recentOutfits = outfits.slice(0, 6);
  const potentialOutfits = outfits.filter(outfit => 
    new Date(outfit.createdAt) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );

  const tabs: TabData[] = [
    { id: 'favourites', name: 'FAVOURITES', icon: HeartIcon, count: favouritesCount },
    { id: 'recent', name: 'RECENT', icon: ClockIcon, count: recentOutfits.length },
    { id: 'potential', name: 'POTENTIAL', icon: SparklesIcon, count: potentialOutfits.length },
    { id: 'analytics', name: 'ANALYTICS', icon: ChartBarIcon, count: null },
  ];

  return (
    <div className="sticky top-0 z-10 bg-white/80 dark:bg-gray-900/80 backdrop-blur-lg border-b border-gray-200 dark:border-gray-700">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <nav className="flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={classNames(
                  activeTab === tab.id
                    ? 'border-gray-900 dark:border-white text-gray-900 dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
                  'group inline-flex items-center py-4 px-1 border-b-2 font-light text-sm tracking-wider uppercase transition-all duration-300'
                )}
              >
                <Icon
                  className={classNames(
                    activeTab === tab.id
                      ? 'text-gray-900 dark:text-white'
                      : 'text-gray-400 dark:text-gray-500 group-hover:text-gray-500 dark:group-hover:text-gray-400',
                    '-ml-0.5 mr-2 h-5 w-5 transition-colors duration-300'
                  )}
                  aria-hidden="true"
                />
                {tab.name}
                {tab.count !== null && (
                  <span className={classNames(
                    activeTab === tab.id
                      ? 'bg-gray-900 dark:bg-white text-white dark:text-gray-900'
                      : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400',
                    'ml-2 inline-block py-0.5 px-2 text-xs font-light rounded-full transition-colors duration-300'
                  )}>
                    {tab.count}
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}